/**
 * Thin top-edge indeterminate progress (Google Drive upload–style feedback).
 * Non-blocking; sits in a stacking context above the video without intercepting input.
 */
export type PreviewActivityBarProps = {
  visible: boolean;
  label?: string;
};

export function PreviewActivityBar({
  visible,
  label = "Loading",
}: PreviewActivityBarProps) {
  if (!visible) return null;

  return (
    <div
      className="ds-preview-activity-bar"
      role="progressbar"
      aria-label={label}
      aria-busy="true"
      aria-valuetext={label}
    >
      <div className="ds-preview-activity-bar__track" aria-hidden>
        <div className="ds-preview-activity-bar__fill" />
      </div>
    </div>
  );
}
